import { GetDocumentRef } from '../../components/document/SaveAndLoadDocument';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import { GetSpecificClient } from '../Clients/getAllClientsForCoBrokers.api';

const firebaseRef = firebase.database();

export default async function sendDocumentToSalesAgent(
	firebase,
	clientEmail,
	coBrokerUid
) {
	GetSpecificClient(clientEmail).then(async (returned) => {
		console.log('returnedddd', returned);

		var thisClient = returned;

		var salesAgentPointer = thisClient.salesAgentPointer;
		var clientKey = thisClient.keyValue;

		var clientRef = firebaseRef.ref(
			'/kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				salesAgentPointer +
				'/myClients/' +
				clientKey
		);

		clientRef.update({
			isCoBrokerComplete: true,
		});

		var salesAgentEmail;

		await firebaseRef
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					salesAgentPointer
			)
			.once('value', (snapshot) => {
				salesAgentEmail = snapshot.val().email;
			});

		var coBrokerEmail;

		await firebaseRef
			.ref('/users/' + thisClient.coBrokerId)
			.once('value', (snapshot) => {
				coBrokerEmail = snapshot.val().email;
			});

		var emailRef = await firebase
			.database()
			.ref('/documentToSalesAgentsEmails/')
			.push();

		await emailRef.set({
			coBrokerEmail: coBrokerEmail,
			salesAgentEmail: salesAgentEmail,
			subject: `${coBrokerEmail} has completed a document for ${thisClient.clientEmail}`,
		});
	});
}
